export const environment = {
  production: true,
  artifactenv: 'test',
  apiUrl: 'https://mspnav-api-qa.isocptest.com/mspnavigator/s111-admin-api-nw/v1/',
  authConfig: {
    clientId: '0oa2embuvord4cWDO0h8',
    issuer: 'https://sso.int.verisk.com/oauth2/auswqnaynoDVhcUjd0h7',
    disablehttpcheck: 'true',
    redirectUri:
      'https://mspnav-nw-siteadmin-serverless-qa.isocptest.com/implicit/callback',
  },
};
